// @flow

import { connect } from 'react-redux';
import './myworks.scss';
import { SearchResults } from '../../components/works';
import { getMyWorks } from '../../services/search';

const mapState = ({ authentication }) => ({
  className: 'my-works',
  useMyWorksNoResults: true,
  title: 'My works',
  subTitle: authentication && authentication.user && authentication.user.name,
  backLinkTo: '/',
  backLinkText: 'Home',
  linkTo: '/mywork',
});

const mapDispatch = {
  getWorks: getMyWorks,
};

export default connect(
  mapState,
  mapDispatch,
)(SearchResults);
